import React from 'react';

/*
 * KycShell — purely presentational wrapper used by every KYC page.
 * It does not touch state, axios, routing or handlers. Pages pass
 * their content as children plus a stepperStep index (0..4).
 *
 * Steps:
 *   0 Intro
 *   1 Personal
 *   2 ID
 *   3 Liveness
 *   4 Done
 */

const STEPS = [
  { key: 'intro',    label: 'Intro' },
  { key: 'personal', label: 'Personal' },
  { key: 'id',       label: 'ID' },
  { key: 'liveness', label: 'Liveness' },
  { key: 'done',     label: 'Done' },
];

export const Stepper = ({ step = 0 }) => {
  return (
    <div className="kyc-stepper" aria-label="Progress">
      {STEPS.map((s, i) => {
        const state = i < step ? 'done' : i === step ? 'active' : 'todo';
        const cls =
          'kyc-step' +
          (state === 'active' ? ' kyc-step--active' : '') +
          (state === 'done' ? ' kyc-step--done' : '');
        return (
          <React.Fragment key={s.key}>
            <div className={cls}>
              <div className="kyc-step__dot">
                {state === 'done' ? (
                  <i className="fa fa-check" aria-hidden="true"></i>
                ) : (
                  i + 1
                )}
              </div>
              <div className="kyc-step__label">{s.label}</div>
            </div>
            {i < STEPS.length - 1 && <div className="kyc-step__bar" />}
          </React.Fragment>
        );
      })}
    </div>
  );
};

const KycShell = ({ step = 0, showStepper = true, children, brandName }) => {
  const logo = typeof window !== 'undefined'
    ? localStorage.getItem('brandlogo')
    : null;
  const name = brandName !== undefined
    ? brandName
    : (typeof window !== 'undefined' ? localStorage.getItem('brandname') : '');

  return (
    <div className="kyc-shell">
      <header className="kyc-header">
        {logo ? (
          <img src={logo} alt="Brand" className="kyc-header__logo" />
        ) : (
          <span style={{ fontWeight: 700, color: 'var(--kyc-text)' }}>
            Identity Verification
          </span>
        )}
      </header>
      <main className="kyc-main">
        <div className="kyc-container">
          {showStepper && <Stepper step={step} />}
          {children}
        </div>
      </main>
      <footer className="kyc-footer">
        Secured by <strong>{name && name !== '{brandname}' ? name : 'KYC'}</strong>
      </footer>
    </div>
  );
};

export const BrowserOnlyWarning = ({ message }) => (
  <div className="kyc-browser-warn">
    <div className="kyc-browser-warn__card">
      <div className="kyc-browser-warn__icon">
        <i className="fa fa-mobile" aria-hidden="true"></i>
      </div>
      <h2 style={{ fontSize: 18, margin: '0 0 8px', fontWeight: 700 }}>
        Mobile device required
      </h2>
      <p style={{ fontSize: 14, color: 'var(--kyc-text-secondary)', margin: 0 }}>
        {message ||
          'This verification is only accessible from mobile devices. Please switch to a mobile device to continue.'}
      </p>
    </div>
  </div>
);

export default KycShell;
